import React from 'react';
import MuiChip, { ChipProps as MuiChipProps } from '@mui/material/Chip';

/**
 * Pioneer Chip — wraps MUI Chip with project defaults.
 *
 * Defaults:
 * - size="small" (Pioneer standard)
 * - variant="outlined" (Pioneer standard)
 *
 * All MUI Chip props are supported and can override defaults.
 */
export interface ChipProps extends MuiChipProps {}

const Chip = React.forwardRef<React.ComponentRef<typeof MuiChip>, ChipProps>(
  function Chip(props, ref) {
    return <MuiChip size="small" variant="outlined" ref={ref} {...props} />;
  },
);

export default Chip;
